module.exports = __webpack_public_path__ + "media/dog-weight/springer-spaniel-white-2082525c.svg";